import BikesPage from "./pages/BikesPage";

function App() {
  return (
    <>
      <BikesPage />
    </>
  );
}

export default App;
